var IFRAME_LOADED_MESSAGE = 'exit-popup-loaded';

export { IFRAME_LOADED_MESSAGE as I };
